export default {
    "name": "InventoryTypes",
    "kind": "HoudiniQuery",
    "hash": "90f92e6118778c33d9a51c6ee3d0948ccb3dfa498337daee0c1951c0465a12df",

    "raw": `query InventoryTypes($filter: InventoryTypeFilter) {
  inventoryTypes(filter: $filter) {
    name
    setId
    id
    typeLabel1
    typeLabel2
    typeLabel3
    typeLabel4
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventoryTypes": {
                "type": "InventoryType",
                "keyRaw": "inventoryTypes(filter: $filter)",

                "selection": {
                    "fields": {
                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "setId": {
                            "type": "Int",
                            "keyRaw": "setId",
                            "nullable": true,
                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "typeLabel1": {
                            "type": "String",
                            "keyRaw": "typeLabel1",
                            "nullable": true,
                            "visible": true
                        },

                        "typeLabel2": {
                            "type": "String",
                            "keyRaw": "typeLabel2",
                            "nullable": true,
                            "visible": true
                        },

                        "typeLabel3": {
                            "type": "String",
                            "keyRaw": "typeLabel3",
                            "nullable": true,
                            "visible": true
                        },

                        "typeLabel4": {
                            "type": "String",
                            "keyRaw": "typeLabel4",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "InventoryTypeFilter"
        },

        "types": {
            "InventoryTypeFilter": {
                "active": "Boolean",
                "vehicle": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=9ca2be828da1eeb72042b31411b6235beadc420859980e64fcc8acd00219b492";